import PropTypes from "prop-types";
import { ACTION_CONTEXT_KEY } from "data/util/ContextedReduceStore";

/*
 * This function uses a bit of JS trickery in order to "hide" a proptypes def
 * on a string, which will then be used by ValidatingDispatcher to validate that
 * actions of this type are dispatched with the correct shape.
 *
 * NB: the 'type' and `ACTION_CONTEXT_KEY` keys are implicitly allowed for any
 * action.
 */
const typedAction = (name, shape) => {
    if (shape == null) {
        throw new Error("typedAction must be passed a non-null shape");
    }
    // noinspection JSPrimitiveTypeWrapperUsage
    name = new String(name); // eslint-disable-line no-new-wrappers
    // noinspection JSPrimitiveTypeWrapperUsage
    name.actionTypes = {
        action: PropTypes.shape({
            ...shape,
            type: PropTypes.instanceOf(String).isRequired,
            [ACTION_CONTEXT_KEY]: PropTypes.string,
        }).isRequired,
    };
    return name;
};

export default process.env.NODE_ENV === "production"
    ? name => name
    : typedAction;



// WEBPACK FOOTER //
// ./app/data/util/typedAction.js